import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import LanternImg from "../assets/PlaceHolder/night.jpg"
import Footer from "../components/Footer"
import Card from "../components/Card"
import PopularServices from "../components/PopularServices";
import ServicesMenu from "../components/ServicesMenu";
import Gallery from "../components/GalleryComponent";
import thumb from "../assets/thumb/maria-lupan-LiUUlnsqwxY-unsplash.jpg";


function Service (){
    return(
        <>
        <Navbar/>
        <Hero 
        cName="hero-mid" 
        heroImg={thumb} 
        title="Gallery"
        btnClass="hide"/>
        <Gallery/>
        <Footer/>
        
        </>
    );
}

export default Service;